import React, { useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getResponsiveSize } from "../../../utils/responsive";
import Typography from "@mui/material/Typography";
import styles from "../../../theme";
import globalStyles from "../../../global";

const brands = [
  "News 1.svg",
  "News 2.svg",
  "News 3.svg",
  "News 4.svg",
  "News 5.svg",
  "News 6.svg",
  "News 7.svg",
  "News 8.svg",
  "News 9.svg",
];

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

// Remove side padding and set width to 100% (not 100vw) to avoid overflow and extra margin.
const CarouselContainer = styled(Box)(({ theme }) => ({
  overflow: "hidden",
  width: "100%",
  whiteSpace: "nowrap",
  padding: 0,
  margin: 0,
  position: "relative",
  boxSizing: "border-box",
  "&:hover .slider-container": {
    animationPlayState: "paused",
  },
}));

const SliderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isPaused",
})(({ isPaused }) => ({
  display: "inline-block",
  animation: "slide 20s linear infinite",
  "@keyframes slide": {
    from: {
      transform: "translateX(0)",
    },
    to: {
      transform: "translateX(-50%)",
    },
  },
  animationPlayState: isPaused ? "paused" : "running",
  className: "slider-container",
}));

const BrandImage = styled("img")(({ theme }) => ({
  width: "auto",
  height: "110px",
  padding: 2,
  display: "inline-block",
  margin: theme.spacing(0, 1),
  transition: "transform 0.3s ease",
  position: "relative",
  backgroundSize: "cover",
  zIndex: 1,
  "&:hover": {
    transform: "scale(1.1)",
    zIndex: 2,
  },
  [theme.breakpoints.down("sm")]: {
    height: "60px", // smaller size on mobile
  },
}));

const News = () => {
  const [isPaused, setPaused] = useState(false);

  const handleMouseEnter = () => setPaused(true);
  const handleMouseLeave = () => setPaused(false);

  return (
    <Box sx={{ py:{xs:"20px",sm:"30px",md:"30px"}, px: 0, mx: 0 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // paddingTop: getResponsiveSize(2),
          px: 0,
          mx: 0,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            ...styles.text1,
            fontWeight: "bold",
            textAlign: "center",
            color: globalStyles.colors.army_green,
            mb: { xs: 2, sm: 6 },
            fontFamily: globalStyles.fonts.primaryUAE,
            textTransform: "uppercase",
            fontSize: {
                xs: "24px", sm: "38px", md: "40px",
            },
         
            paddingX: {
              xs: getResponsiveSize(3),
              sm: getResponsiveSize(20),
              md: getResponsiveSize(30),
            },
          }}
        >
          FEATURED IN
        </Typography>
      </Box>

      <CarouselContainer
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <SliderContainer isPaused={isPaused}>
          {brands.map((brand, index) => (
            <BrandImage
              key={index}
              src={`${imageBaseUrl}${brand}`}
              alt={`Brand ${index + 1}`}
              draggable={false}
              style={{ verticalAlign: "middle" }}
            />
          ))}
        </SliderContainer>
      </CarouselContainer>
    </Box>
  );
};

export default News;
